import { OverviewScreen } from '@/components/overview/OverviewScreen';

export function OverviewPage() {
  return <OverviewScreen />;
}
